import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS } from '../_constants/constants';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';

@Injectable()
export class SmsURLService {

    constructor(private http: Http, private ds: DialogService, private translate: TranslateService) {
    }

    sendOTP(newMsisdn: string, subValue: string, opcoValue: string, ds: DialogService){
        DetailsComponent.incrementRunningRequests();
        const URL = (environment.BASE_URL_BACKEND + APIURLS.SEND_OTP);
        console.log(URL);
        var enable_nonvf = false;
        if(opcoValue.toUpperCase() === 'NV'){
            enable_nonvf = true
        }

        const headers = new Headers();
        headers.append('x-int-opco-id', opcoValue);
        headers.append('Content-Type', 'application/json; charset=utf-8');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        const payload = '{\"msisdn\": \"' + newMsisdn + '\", \"autosms\": \"true\", \"seamlessIdState\": \"f1\", \"enable-nonvf\": \"'+ enable_nonvf +'\", \"prepend-msg\": \"Customer care agent asks for permission to verify OTP\", \"smsurl\": "/smsurl/{tokenId}/code/\" }';
        this.http.post(URL, payload, options).subscribe(
            response => {
                DetailsComponent.decrementRunningRequests();
                this.ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                    });
            },
            err => {
                DetailsComponent.decrementRunningRequests();

                if(err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }
                // if(err.json().code == "IDP_ERROR"){
                //     this.ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     this.ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
            });
    }

    verifyOTP(tokenID: string, pinCode: string, ds: DialogService){
        DetailsComponent.incrementRunningRequests();
        const URL = (environment.BASE_URL_BACKEND + APIURLS.VERIFY_OTP).replace('{token}', tokenID);
        console.log(URL);

        const headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        const payload = '{\"code\": \"' + pinCode + '\" }';

        this.http.post(URL, payload, options).subscribe(
            response => {
                console.log("Pin Success");
                console.log(response.json());
                DetailsComponent.decrementRunningRequests();
                this.ds.addDialog(NotificationDialogComponent,
                    {
                        success: true,
                        message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                    });
            },
            err => {
                DetailsComponent.decrementRunningRequests();

                if(err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }
                
                // if(err.json().code == "IDP_ERROR"){
                //     this.ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     this.ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
            });
    }

}


// WEBPACK FOOTER //
// ./src/app/_services/smsurl.service.ts